import Categories from './Categories'
export type { CategoryUiData } from './Categories'

export default Categories
